import React from "react";
import { Form, Tooltip } from "antd";
import DataGrid from "../../../core/ui/components/grid/DataGrid";
import DataGridConfigurationBuilder from "../../../core/ui/components/grid/DataGridConfigurationBuilder";
import TickBox from "../../../core/ui/components/grid/TickBox";
import AttachmentTypeForm from "./AttachmentTypeForm";
import { IGenericCodebookItem } from "../../../codebooks/model/GenericCodebookItem";
import { TFormAction } from "../../../core/ui/components/grid/FormAction";
import { IOrganisation } from "../../../organisations/model/Organisation";
import { TAttachmentTypePresentationModel } from "../../../organisations/presenter/model/AttachmentTypePresentationModel";

interface AttachmentTypeGridProps {
  translate: any;
  attachmentTypes: TAttachmentTypePresentationModel[];
  createAttachmentType: any;
  updateAttachmentType: any;
  referenceLoader?: boolean;
  contentTypes: IGenericCodebookItem[];
  organisationId?: number;
  organisations: IOrganisation[];
}
const AttachmentTypeGrid: React.FC<AttachmentTypeGridProps> = ({
  translate,
  attachmentTypes,
  createAttachmentType,
  updateAttachmentType,
  referenceLoader,
  contentTypes,
  organisationId,
  organisations
}) => {
  const builder = DataGridConfigurationBuilder({
    translate,
    resourcePrefix: "editors.attachment_types"
  });
  const columns = builder.buildColumns(
    {
      name: "",
      sortable: false,
      align: "center",
      render: (record) => {
        return record.organisationId ? (
          <Tooltip
            title={`Tip priloga specifičan za organizaciju ${record.organisationName}`}
          >
            <i className="fas fa-building" />
          </Tooltip>
        ) : (
          <Tooltip title={"Globalni tip priloga"}>
            <i className="fa fa-globe" />
          </Tooltip>
        );
      }
    },
    "name",
    "contentTypeName",
    {
      name: "anonymisation_required",
      dataKey: "anonymisationRequired",
      sortable: false,
      align: "center",
      render: (record) => <TickBox value={record.anonymisationRequired} />
    },
    {
      name: "valid",
      dataKey: "valid",
      sortable: false,
      align: "center",
      render: (record) => <TickBox value={record.valid} />
    }
  );

  const [CreateForm] = Form.useForm();
  const [UpdateForm] = Form.useForm();

  const updateFormActions: TFormAction[] = [];
  updateFormActions.push({
    disable: (record: TAttachmentTypePresentationModel) =>
      organisationId != null && record.organisationId == null,
    key: "submit",
    label: translate("data_grid.modal.actions.save"),
    onClick: updateAttachmentType,
    type: "primary"
  });
  return (
    <DataGrid
      updateFormActions={updateFormActions}
      title={translate("editors.attachment_types.title")}
      columns={columns}
      translate={translate}
      dataSource={attachmentTypes || []}
      allowCreate={true}
      allowUpdate={true}
      addButtonText={translate("editors.attachment_types.add_new_text")}
      createForm={
        <AttachmentTypeForm
          translate={translate}
          form={CreateForm}
          contentTypes={contentTypes || []}
          organisationId={organisationId}
          organisations={organisations}
        />
      }
      createModalTitle={`${translate(
        "editors.attachment_types.create_modal_title"
      )}`}
      loading={referenceLoader}
      onCreate={(e) => {
        createAttachmentType(e);
      }}
      updateForm={
        <AttachmentTypeForm
          translate={translate}
          form={UpdateForm}
          contentTypes={contentTypes || []}
          organisationId={organisationId}
          organisations={organisations}
        />
      }
      updateModalTitle={`${translate("editors.attachment_types.title")}`}
      onUpdate={updateAttachmentType}
      booleanColumnKeys={["valid"]}
      createModalClass={"modal-width"}
      updateModalClass={"modal-width"}
      keyProperty={"id"}
      CreateFormInstance={CreateForm}
      UpdateFormInstance={UpdateForm}
      createActionPosition={"topRight"}
    />
  );
};
export default AttachmentTypeGrid;
